package com.jingfangpai.common.constant

import kotlinx.serialization.Serializable


@Serializable
enum class Error {
    NA,
    操作失败,
    操作未被许可,
    参数异常,
    不支持此操作,
    对象不存在,
    程序内部错误,
    配置错误,
    外部服务异常,
    用户输入错误,
    未知错误,
    权限不足,
    重复操作;

    fun equalsName(otherName: String?): Boolean {
        return if (otherName == null) false else name == otherName
    }

    override fun toString(): String {
        return name
    }

}
